const tagsModule = {
  firestorePath: "tags/tags",
  firestoreRefType: "doc", // or 'doc'
  moduleName: "tags",
  statePropName: "tags",
  namespaced: true, // automatically added
  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {},
  mutations: {},
  actions: {}
};
export default tagsModule;
